module.exports = __webpack_public_path__ + "static/media/ge.a1295792.svg";